import { render } from "./AsideBar.vue?vue&type=template&id=0edfcf4e&scoped=true"
import script from "./AsideBar.vue?vue&type=script&lang=js"
export * from "./AsideBar.vue?vue&type=script&lang=js"

import "./AsideBar.vue?vue&type=style&index=0&id=0edfcf4e&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edfcf4e"]])

export default __exports__